module.exports = __webpack_public_path__ + "media/images/logo-1aa438d2ca290e441471255b381825b0.svg";